<template>
  <!--
      作者：kmdshop
      时间：2020-06-01
      描述：插件中心-事故上报-添加
    -->
    <el-dialog
    title="添加事故上报"
    :visible.sync="dialogVisible"
    @close="dialogFormVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="50%"
  >

  <div class="product-add pb50">

    <el-form size="small" :model="form" ref="form" :rules="rules" label-width="100px">

      <el-form-item label="事故上报名称" prop="name"><el-input v-model="form.name" placeholder="请输入事故上报名称" class="max-w460"></el-input></el-form-item>


<el-form-item label="检查项" prop="inspection_item_file" required>
  <el-button icon="el-icon-picture-outline" @click="openFileUpload">选择请上传检查项图片</el-button>

  <div v-if="form.inspection_item_file" class="inspection-item-preview">
    <el-image
      :src="form.inspection_item_file"
      style="width: 120px; height: 120px; border: 1px solid #eaeaea; border-radius: 4px; margin-top: 8px;"
      fit="cover"
    ></el-image>
  </div>

  <div style="color: #67C23A; font-size: 12px; margin-top: 5px; word-break: break-all;">
    {{ form.inspection_item_file }}
  </div>
  <div v-if="uploadStatus === 'error'" style="color: #F56C6C; font-size: 12px; margin-top: 5px;">
    图片上传失败，请重新上传
  </div>
  <div slot="tip" class="el-upload__tip">支持 jpg/jpeg/png/gif/bmp/webp 等图片格式上传</div>
</el-form-item>
<!-- <el-form-item label="分类" prop="category">
  <el-select v-model="form.category" placeholder="请选择分类" class="max-w460">
    <el-option label="有事故" value="有事故"></el-option>
    <el-option label="无事故" value="无事故"></el-option>
  </el-select>
</el-form-item> -->
<!-- <el-form-item label="管理方式" prop="management_method">
  <el-select v-model="form.management_method" placeholder="请选择管理方式" class="max-w460">
    <el-option label="线上" value="线上"></el-option>
    <el-option label="线下" value="线下"></el-option>
  </el-select>
</el-form-item> -->
<!-- <el-form-item label="责任人" prop="responsible_person">
  <el-select v-model="form.responsible_person" placeholder="请选择责任人" class="max-w460"> -->
    <!-- 人员选项需根据实际接口渲染 -->
  <!-- </el-select> -->
<!-- </el-form-item> -->
<!-- <el-form-item label="事故车牌号" prop="accident_license_plate">
  <el-input v-model="form.accident_license_plate" placeholder="请输入事故车牌号" class="max-w460"></el-input>
</el-form-item> -->
<!-- <el-form-item label="事故发生时间" prop="accident_occurrence_time" required>
  <div class="block">
    <el-date-picker
      size="small"
      v-model="form.accident_occurrence_time"
      type="datetime"
      value-format="yyyy-MM-dd HH:mm:ss"
      placeholder="选择日期时间"
    ></el-date-picker>
  </div>
</el-form-item> -->
<!-- <el-form-item label="事故类型" prop="accident_type">
  <el-select v-model="form.accident_type" placeholder="请选择事故类型" class="max-w460">
    <el-option label="人伤事故" value="人伤事故"></el-option>
    <el-option label="物损事故" value="物损事故"></el-option>
  </el-select>
</el-form-item>
<el-form-item label="事故报告" prop="accident_report">
  <el-input type="textarea" v-model="form.accident_report" placeholder="请输入事故报告" class="max-w460"></el-input>
</el-form-item>
<el-form-item label="事故责任认定书" prop="accident_liability_certificate">
  <el-input type="textarea" v-model="form.accident_liability_certificate" placeholder="请输入事故责任认定书" class="max-w460"></el-input>
</el-form-item>
<el-form-item label="事故处理" prop="accident_disposal">
  <el-input type="textarea" v-model="form.accident_disposal" placeholder="请输入事故处理情况" class="max-w460"></el-input>
</el-form-item> -->
<el-form-item label="说明" prop="description">
  <el-input type="textarea" v-model="form.description" placeholder="请输入说明" class="max-w460"></el-input>
</el-form-item>
<!-- <el-form-item label="事故发生地点" prop="accident_occurrence_place">
  <el-input v-model="form.accident_occurrence_place" placeholder="请输入事故发生地点" class="max-w460"></el-input>
</el-form-item>
<el-form-item label="事故性质" prop="accident_nature">
  <el-select v-model="form.accident_nature" placeholder="请选择事故性质" class="max-w460">
    <el-option label="一般事故" value="一般事故"></el-option>
    <el-option label="较大事故" value="较大事故"></el-option>
    <el-option label="重大事故" value="重大事故"></el-option>
    <el-option label="特大事故" value="特大事故"></el-option>
  </el-select>
</el-form-item>
<el-form-item label="事故责任" prop="accident_liability">
  <el-select v-model="form.accident_liability" placeholder="请选择事故责任" class="max-w460">
    <el-option label="发生两车以上物损事故主要责任（含）以上" value="发生两车以上物损事故主要责任（含）以上"></el-option>
    <el-option label="发生伤人事故负次要责任" value="发生伤人事故负次要责任"></el-option>
    <el-option label="发生伤人事故负全部责任" value="发生伤人事故负全部责任"></el-option>
    <el-option label="发生伤人事故负同等或主要责任" value="发生伤人事故负同等或主要责任"></el-option>
    <el-option label="发生财损事故负同等责任以上" value="发生财损事故负同等责任以上"></el-option>
  </el-select>
</el-form-item>
<el-form-item label="事故照片" prop="accident_photos">
  <div class="draggable-list">
    <draggable v-model="form.accident_photos" class="wrapper" :options="{ animation: 150 }">
      <transition-group>
        <div v-for="(item, index) in form.accident_photos" :key="item.file_path">
          <div class="item">
            <img v-img-url="item.file_path" alt="请上传事故照片"/>
            <a href="javascript:void(0);" class="delete-btn" @click.stop="deleteImg(index)">
              <i class="el-icon-close"></i>
            </a>
          </div>
        </div>
      </transition-group>
    </draggable>
    <div class="item img-select" @click.stop="openUpload()">
      <i class="el-icon-plus"></i>
    </div>
  </div>
</el-form-item> -->
      <!-- <el-form-item label="排序" prop="name"><el-input v-model="form.sort" placeholder="请输入排序" class="max-w460"></el-input></el-form-item> -->
       

    
      <!--提交-->
      <div class="common-button-wrapper">
        <el-button size="small" type="info" @click="cancelFunc">取消</el-button>
        <el-button size="small" type="primary" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
    </el-form>
     <!--业务附件上传组件-->
     <Upload v-if="isupload" :config="{ total: 9 }" :isupload="isupload" @returnImgs="returnProductImgsFunc">上传图片
    </Upload>
     <Upload v-if="isuploadFile" :config="{ total: 1, accept: 'image' }" @returnImgs="returnFilesFunc">上传图片</Upload>
 </div>
</el-dialog>
  
</template>

<script>
import Ma_accident_reportingApi from '@/api/ma_accident_reporting.js';

import Upload from '@/components/file/Upload';
import draggable from "vuedraggable";
import Uediter from '@/components/UE.vue';
export default {
  components: {

     /*图片上传*/
     Upload: Upload,

     draggable,
     Uediter
  },
  data() {
    return {
      uploadStatus:'',
      isuploadFile:false,
      /*是否上传图片*/
      isupload: false,
      isImg: false,  
         /*富文本配置*/
         ueditor: {
        text: '',
        config: {
          initialFrameWidth: 400,
          initialFrameHeight: 500
        }
      },
      /*form表单数据*/
      form: {
        name: '',
        code: 'custom',
        image:[],
        // categorya:{},
        sort:50,
        intro:"",
        accident_photos:[],
        inspection_item_file:'',
        description:''
      },
      loading: false,
      /*验证规则*/
      rules: {
        name: [{ required: true, message: '请输入事故上报名称', trigger: 'blur' }],
        inspection_item_file: [{ required: true, message: '请上传检查项图片', trigger: 'blur' }],
        description: [{ required: true, message: '请输入说明', trigger: 'blur' }],
      },
      dialogVisible:false,
      iscategorya:false,
      excludeIds:[],
      isProductUpload:false,
      code:"album"
    };
  },
  created() {
    console.log(11111)
    this.dialogVisible = this.open_add;
  },
  props: ["open_add"],
  methods: {
    returnFilesFunc(e) {
      this.uploadStatus = ''

      // 仅取第一个（控件配置 total=1）
      if (e != null && e.length > 0) {
        const file = e[0] || {}
        const filePath = file.file_path || ''
        const realName = file.real_name || ''
        const extSource = realName || filePath
        const ext = extSource.split('.').pop().toLowerCase()

        const imgExpt = ['bmp', 'jpg', 'jpeg', 'png', 'gif', 'webp']
        if (!imgExpt.includes(ext)) {
          this.$message.error('图片类型有误,请选择正确的图片格式')
          this.form.inspection_item_file = ''
          this.uploadStatus = 'error'
          this.isuploadFile = false
          return
        }

        this.form.inspection_item_file = filePath
        this.uploadStatus = 'success'
        this.$nextTick(() => {
          this.$refs.form && this.$refs.form.validateField('inspection_item_file')
        })
      }

      this.isuploadFile = false;
    },
    openFileUpload() {
      this.uploadStatus = ''
      this.isuploadFile = true;
    },
    chooseCategory(){
      this.iscategorya = true;
    },
     /*上传*/
     openUpload(e) {
      this.isupload = true;
    },


     /*关闭弹窗*/
     dialogFormVisible(result) {
      this.$emit("close", { openDialog: false,"type":"" });
    },
    cancelFunc(){//取消
      this.dialogFormVisible("error")
    },

    onSubmit() {
      let self = this;
      let form = self.form;
      //form.intro = this.$refs.ue.getUEContent();
      self.$refs.form.validate(valid => {
        if (valid) {
          self.loading = true;
          Ma_accident_reportingApi.add(form, true)
            .then(data => {
              self.loading = false;
              self.$message({
                message: data.msg,
                type: 'success'
              });
              self.dialogFormVisible("error")
            })
            .catch(error => {
              self.loading = false;
            });
        }
      });
    },

    /*取消添加，返回任务列表*/
    cancelFunc() {
      this.$emit("close", { openDialog: false,"type":"" });
    },
     /*打开上传图片*/
     openProductUpload: function (code) {
      this.isProductUpload = true;
      this.code = code
    },

    /*上传业务附件*/
    returnProductImgsFunc(e) {
      if (e != null) {
        let imgExpt = ["bmp", "jpg", "jpeg", "png", "gif"];
        let prevent = false;
        console.log(typeof imgExpt);
        e.forEach((element) => {
          let data_array = element.file_path.split(".");
          let ext = data_array[data_array.length - 1];
          imgExpt.forEach((e) => {
            if (e === ext) {
              prevent = true
              return false
            }
          });
        });

        if (!prevent) {
          this.$message.error("图片类型有误,请选择正确的图片格式");
          return false;
        }
        let imgs = this.form.accident_photos.concat(e);
        this.$set(this.form, "accident_photos", imgs);
      }
      
      this.isupload = false;
    },

    /*删除业务附件*/
    deleteImg(index) {
      this.form.accident_photos.splice(index, 1);
      
    },

  }
};
</script>

<style>
.edit_container {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.ql-editor {
  height: 400px;
}


.draggable-list {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
}

.draggable-list .wrapper > span {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .item {
  position: relative;
  width: 110px;
  height: 110px;
  margin-top: 10px;
  margin-right: 10px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #dddddd;
}

.draggable-list .delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background: red;
  line-height: 16px;
  font-size: 16px;
  color: #ffffff;
  display: none;
}

.draggable-list .item:hover .delete-btn {
  display: block;
}

.draggable-list .item img {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  max-height: 100%;
  max-width: 100%;
}

.draggable-list .img-select {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #dddddd;
  font-size: 30px;
}

.draggable-list .img-select i {
  color: #409eff;
}

.inspection-item-preview {
  margin-top: 4px;
}
</style>



// WEBPACK FOOTER //
// src/views/plus/ma_accident_reporting/index/part/add.vue